<div class="flex justify-between items-center mb-4">
  <h2 class="text-2xl font-semibold">Línea de negocio</h2>
  <button
    (click)="openModal('add')"
    class="bg-primary text-white px-4 py-2 rounded transform transition-transform duration-200 cursor-pointer hover:scale-105"
    [disabled]="loadingBusinessLines"
  >
    Crear nueva línea de negocio
  </button>
</div>
<app-loading
  *ngIf="loadingBusinessLines"
  text="Cargando líneas de negocio"
></app-loading>
<div
  class="bg-white rounded border border-gray-200"
  *ngIf="!loadingBusinessLines"
>
  <app-table-generic
    [columns]="columns"
    [data]="businessLines"
    [actions]="actions"
    [showPagination]="false"
    (edit)="openModal('edit', $event)"
  >
  </app-table-generic>
</div>
<app-modal-form
  *ngIf="mostrarModalAgregar"
  [title]="'Crear línea de negocio'"
  [form]="formAgregar"
  [fields]="fieldsAgregar"
  [loading]="loadingAgregar"
  (formSubmit)="crearBusinessLine()"
  (cancel)="mostrarModalAgregar = false"
  submitText="Crear"
>
</app-modal-form>
<app-modal-form
  *ngIf="mostrarModalEditar"
  [title]="'Editar línea de negocio'"
  [form]="formEditar"
  [fields]="fieldsEditar"
  [loading]="loadingEditar"
  submitText="Actualizar"
  (formSubmit)="actualizarBusinessLine()"
  (cancel)="mostrarModalEditar = false"
>
</app-modal-form>
